import { createFromIconfontCN } from '@ant-design/icons'

export const IconFont = createFromIconfontCN({
  scriptUrl: ['//at.alicdn.com/t/font_2366388_nu2yhcw3grn.js']
})
